import type { HTMLAttributes, ReactNode } from "react";
import { type DateValue, RangeCalendarContext, useSlottedContext } from "react-aria-components";
import { cx } from "@/utils/cx";

interface RangePresetButtonProps extends HTMLAttributes<HTMLButtonElement> {
  value: { start: DateValue; end: DateValue };
  disabled?: boolean;
  subtext?: string;
}

export const RangePresetButton = ({
  value,
  className,
  children,
  disabled,
  subtext,
  ...props
}: RangePresetButtonProps) => {
  const context = useSlottedContext(RangeCalendarContext);

  const isSelected = context?.value?.start?.compare(value.start) === 0 && context?.value?.end?.compare(value.end) === 0;

  return (
    <button
      {...props}
      disabled={disabled}
      className={cx(
        "rounded-md px-3 py-2 text-left text-sm font-medium outline-focus-ring transition duration-100 ease-linear focus-visible:outline-2 focus-visible:outline-offset-2",
        disabled ? "cursor-not-allowed text-disabled opacity-50" : "cursor-pointer",
        !disabled && isSelected
          ? "bg-active text-secondary_hover hover:bg-secondary_hover"
          : !disabled && "text-secondary hover:bg-primary_hover hover:text-secondary_hover",
        className,
      )}
    >
      <div className="flex flex-col gap-0.5">
        <div>{children}</div>
        {subtext && <div className="text-xs text-tertiary">{subtext}</div>}
      </div>
    </button>
  );
};
